import api from "../../api";

export const verifyReCAPTCHA = async (token: string): Promise<boolean> => {
  const response = await api.post(`verify-recaptcha`, { token });
  return response.data.success;
};
